<template>
  <div class="contact_app">
    <div class="content">
      <ul>
        <li>
          <div class="c_l">
            <img src="@/assets/appimg/index/icon/navigation_1address.svg" />
            <span>地址：广东省广州市番禺区沙头街银平路98号2栋7楼</span>
          </div>
        </li>
        <li>
          <div class="c_l">
            <img src="@/assets/appimg/index/icon/navigation_2telephone.svg" />
            <span>电话：林经理 15920366002、4008838316</span>
          </div>
<!--          <div class="c_r">-->
<!--            <img src="@/assets/appimg/index/icon/navigation_3weixin.svg" />-->
<!--            <span>微信：zhny618</span>-->
<!--          </div>-->
        </li>
        <li class="website-row">
          <div class="c_l">
            <img src="@/assets/appimg/index/icon/navigation_4website.svg" />
            <span>官网：</span>
          </div>
          <div class="c_r website-links">
            <div class="link-item"><a class="ci-link" href="http://www.suringscm.com" target="_blank" @click.prevent.stop="openUrl('http://www.suringscm.com')">穗盈 www.suringscm.com</a></div>
            <div class="link-item"><a class="ci-link" href="http://www.visfarm.com" target="_blank" @click.prevent.stop="openUrl('http://www.visfarm.com')">智慧农业 www.visfarm.com</a></div>
            <div class="link-item"><a class="ci-link" href="http://www.sciento.cn" target="_blank" @click.prevent.stop="openUrl('http://www.sciento.cn')">赛通科技 www.sciento.cn</a></div>
            <div class="link-item"><a class="ci-link" href="http://www.megoai.com" target="_blank" @click.prevent.stop="openUrl('http://www.megoai.com')">米果智能 www.megoai.com</a></div>
            <div class="link-item"><a class="ci-link" href="http://www.maixiaocai.com" target="_blank" @click.prevent.stop="openUrl('http://www.maixiaocai.com')">麦小菜 www.maixiaocai.com</a></div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "ContactApp",
  data () {
    return {}
  },
  methods: {
    openUrl (url) {
      window.open(url, '_blank') || (window.location.href = url)
    }
  }
}
</script>
<style lang="scss" scoped>
.ci-link {
  text-decoration: underline;
}
.website-row {
  align-items: flex-start;
  //line-height: 2;
}
.website-links {
  flex: 1;
  width: auto;
  display: block;
  word-break: break-all;
}
.link-item {
  margin-bottom: 0.6rem;
  a {
    color: #68779d;
    text-decoration: none;
  }
  &:last-child {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/app/components/contact.vue